var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"app",style:({ background: _vm.$vuetify.theme.themes[_vm.theme].background })},[(_vm.loading)?_c('layout-loading',{attrs:{"overlay":_vm.loadingOverlay}}):_c(_vm.resolveLayout,{tag:"component"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }